// extracted by mini-css-extract-plugin
export default {"list":"burger-constructor_list__ehxn5","toppings":"burger-constructor_toppings__3cB5t","info":"burger-constructor_info__4m1o8"};